import { Body1, Body1Stronger, Label, LabelProps, mergeClasses } from "@fluentui/react-components";
import { FieldProps } from "./Types";
import React from "react";
import { useStyles } from "./Styles";

type CartItemOptionGroupLabelProps = LabelProps & Omit<FieldProps, "helpers">;

export const CartItemOptionGroupLabel = React.forwardRef<
  HTMLLabelElement,
  CartItemOptionGroupLabelProps
>((props: CartItemOptionGroupLabelProps, ref: React.ForwardedRef<HTMLLabelElement>) => {
  const styles = useStyles();
  const { field, meta, ...rest } = props;
  return (
    <Label ref={ref} {...rest} className={props.className} htmlFor={field.name}>
      <Body1Stronger className={styles.labelText}>{field.value.name}</Body1Stronger>
      {meta.touched && meta.error && (
        <Body1 role="alert" className={mergeClasses(styles.validation, styles.labelError)}>
          {meta.error}
        </Body1>
      )}
      <span className={styles.labelRight}>
        {!field.value.isSingleSelect && field.value.maximum > 0 && (
          <Body1 className={styles.maximum}>{`(Max ${field.value.maximum})`}</Body1>
        )}
      </span>
    </Label>
  );
});

CartItemOptionGroupLabel.displayName = "CartItemOptionGroupLabel";
